<template>
  <article class="field"
        @click="stopPropagation">
        <label 
          for="service"
          class="visually-hiddenx"
          v-show="!customInputValue.text">
            <span class="field-label">Start Typing for suggestions</span>
        </label>
        <select
            ref="main-select" 
            name="brand" 
            v-model="selectedService.id"
            aria-hidden="true"
            tabindex="-1" 
            class="visually-hidden">
              <option
                  v-for="service in services"
                  :key="service.id" 
                  :value="service.id">{{service.name}}</option>
        </select>
        <section class="autocomplete">
          <input   
            class="ryoma-input ryoma-input--slim"
            ref="custom-input"
            id="service"
            v-model="customInputValue.text"
            aria-owns="autocomplete-options--service"
            autocapitalize="none" 
            type="text" 
            autocomplete="off"
            aria-autocomplete="list" 
            role="combobox"    
            aria-expanded="false"
            @keyup="updateField"
						@blur="hideMenu">
            <!--  -->
            <svg 
							xmlns="http://www.w3.org/2000/svg" 
							focusable="false" 
							fill="#ccc"
							fill-rule="evenodd" 
							clip-rule="evenodd"
							width="24" 
							height="24" 
							viewBox="0 0 24 24"
							@click="customInputValue.text ? clearInput() : onTextBoxDownPressed()">
							<path v-if="customInputValue.text" d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.597 17.954l-4.591-4.55-4.555 4.596-1.405-1.405 4.547-4.592-4.593-4.552 1.405-1.405 4.588 4.543 4.545-4.589 1.416 1.403-4.546 4.587 4.592 4.548-1.403 1.416z"/>
							<path v-if="!customInputValue.text" d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11-11-4.929-11-11 4.929-11 11-11zm5.247 8l-5.247 6.44-5.263-6.44-.737.678 6 7.322 6-7.335-.753-.665z"/>
						</svg>
            <ul 
							ref="datalist"
							v-if="showList"
							id="autocomplete-options--service"
							role="listbox" 
							class="hidden"
							@keydown="onMenuKeyDown">

							<li  
								v-for="(service) in activeOptions"
								:id="`autocomplete_${service.id}`"
								:key="service.id"
								role="option" 
								tabindex="-1"
								aria-selected="false"
								@click="selectOption(service)">
	
								{{service.name}}<br/>
								<span>{{service.excerpt}}</span>
							</li>
            </ul>

            <aside 
							aria-live="polite" 
							role="status" 
							class="visually-hidden">

							{{activeOptions.length}} results available.
            </aside>
        </section>

    </article>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/helpers/helpers'

export default {
  name: 'ryoma-input',
  props: ['name', 'type', 'look', 'suggestions', 'id', 'label', 'placeholder', 'hide'],
  watch: {
    selectedService (val) {
			this.$emit('serviceSelected', val);
			this.hideMenu();
		},
		showList (val) {
			val && this.focusBox()
    }
  },
  data() {
      return {
        est: document.activeElement,
        showList: false,
        blockClosing: false,
				selectedService: {
					id: null,
					name: null
				},
				customInputValue: {
						text: ''
				},
				activeOptions: [],
				activeOptionId: null
      }
  },
  computed: {
    ...mapGetters({
			services: 'services'
    }),
    hiddenSelect () {
			return this.$refs['main-select'] 
		}
  },
  methods: {
		isSelected (i) {
			return i === 0;
		},
		clearInput () {
      this.customInputValue.text = null
      this.activeOptions = helpers.getAllOptions(this.hiddenSelect, this.services);
			this.focusBox()
		},
    focusBox (box) {
				if(box) {
					this.$refs['custom-input'].setAttribute('aria-selected', 'false')
					
					if(box.tagName && box.tagName.toLowerCase() === 'li') {
						box.focus();
						box.setAttribute('aria-selected', 'true')
						this.activeOption = this.$refs.datalist.querySelector('li:first-child')
					} else {
						const findNextElement = box === 'next' ? this.activeOption.nextSibling : this.activeOption.previousSibling
						if (!findNextElement) {
							const nextToActivate = box === 'next' ? 'li:first-child' : 'li:last-child'
							this.activeOption.setAttribute('aria-selected', 'false')
							this.activeOption = this.$refs.datalist.querySelector(nextToActivate)
							this.activeOption.focus()
							this.activeOption.setAttribute('aria-selected', 'true')
							return
						}
						this.activeOption.setAttribute('aria-selected', 'false')

						findNextElement.focus()
						findNextElement.setAttribute('aria-selected', 'true')
						this.activeOption = findNextElement
					}
				} else {
					this.activeOption && this.activeOption.setAttribute('aria-selected', 'false')
					this.$refs['custom-input'].focus()
					this.$refs['custom-input'].setAttribute('aria-selected', 'true')
				}
    },
    stopPropagation (event) {
        event.stopPropagation();
    },
    selectOption (service) {
			
        this.selectedService = service
        this.customInputValue.text = this.selectedService.name
        
        // this.hideMenu();
        this.focusBox();
    },
    updateField (e) {
			
      switch (e.keyCode) {
          
          case helpers.keys.esc:
          case helpers.keys.up:
          case helpers.keys.left:
          case helpers.keys.right:
          case helpers.keys.space:
          case helpers.keys.enter:
          case helpers.keys.shift:
          // ignore these keys otherwise the menu will show briefly
          break;
      
          case helpers.keys.tab:
              // console.log(e)
              this.hideMenu()
              break;
          case helpers.keys.down:
              // console.log(e)
              this.onTextBoxDownPressed()
              break;
          default:
              // console.log(e)
              this.onTextboxType(e)
              break;
      }
        
    },
    showMenu () {
      this.showList = true;
    },
    hideMenu () {
      if(this.blockClosing) {
        this.blockClosing = !this.blockClosing
        return
      }
			setTimeout(() => {
				this.showList = false;
			},250 )
    },
    buildMenu (options) {
        this.activeOptions = []
        this.activeOptions = options
    },
    onTextboxType (e) {
        if(e.key.trim().length > 0) {
            const options = helpers.getOptions(this.customInputValue.text.trim().toLowerCase(), this.hiddenSelect, this.services);
            // build the menu based on the options
            this.buildMenu(options);
            // show the menu
            this.showMenu();  
        }
    },
    onTextBoxDownPressed () {
      this.blockClosing = true

			if(this.activeOptions.length && this.$refs.datalist) {
				const option = this.$refs.datalist.querySelector('li:first-child')
				this.focusBox(option)
			}
				this.customInputValue.text = this.$refs['custom-input'].value
        if(this.customInputValue.text.length === 0) {

            this.activeOptions = helpers.getAllOptions(this.hiddenSelect, this.services);
            this.buildMenu(this.activeOptions);
            // show the menu
            this.showMenu();
            
        }
		},
		onMenuKeyDown (e) {

			switch (e.keyCode) {
				case helpers.keys.up:
          e.preventDefault()
					this.focusBox('prev')
					break;
				case helpers.keys.down:
          e.preventDefault()
					this.focusBox('next')
					break;
				case helpers.keys.enter:
					const activeElement = parseInt(document.activeElement.id.split('_')[1])
					const option = this.services.filter(service => service.id === activeElement)
					option && this.selectOption(option[0])
					break;
				case helpers.keys.space:
					
					break;
			
				default:
					this.focusBox();
					break;
			}
		}
  }
}
</script>

<style lang="scss" scoped>
	@import '@/styles/_mixins.scss';
	
.field {
  position: relative;
  width: 100%;
  max-width: 80vw;

  label {
      position: absolute;
      top: 35px;
      left: 0;
      color: #333;
      font-size: .8rem;
  }

  .autocomplete {
      position: relative;

        [role=listbox] { 
            position:absolute;
            border-radius: $radius;
            z-index: 1;
            margin: 0;
            margin-top: 1vmin;
            padding-left: 0;
            list-style-type: none;
            width: 100%;
            background:  darken(white, 5%);
            color: #333;
            max-height: 20em;
            overflow-y: scroll; 
            -webkit-overflow-scrolling: touch;

            li {
                font-weight: 700;
                padding: 2vmin;
                cursor: pointer;
                transition: all .25s ease-out;
                border-bottom: 2px solid $secondary;

								&:hover,
								&[aria-selected="true"] {
                  outline: none;
                  border-bottom: none;
                  box-shadow: inset 0px 0px 10px rgba(0,0,0,0.1);
                  background: white;
                  color: $secondary;
                }

                span {
                  color: #333;
                  font-weight: 40;
                  margin-top: 1vmin;
                  display: block;
                  line-height: 1.2;
                  font-size: 80%;
                  font-style: italic;
                }
            }
        }
        [role=combobox] {

					&:focus {
						border: 1px solid $secondary;
					}

					+ svg {
						cursor: pointer;
						position: absolute;
						right: 2vmin;
						top: 50%;
						transform: translate(0, -50%);
					}
        }

        [role=option] {
					&[aria-selected="true"] { 
					background-color: #005EA5;
					border-color: #005EA5;
					color: #ffffff;
        }
    }
  }
}
</style>